import { useMemo, useState } from "react";
import { useToast } from "../../../Hooks/ToasContext";
import { IArtEntity } from "../../../Services/api/arts/arts.interface";
import { DestroyArtsUseCase } from "../../../Usecase/Arts/destroy-arts-usecase";
import { ListArtsUseCase } from "../../../Usecase/Arts/list-arts-usecase";
import { ListCustomersUseCase } from "../../../Usecase/Customers/list-customers-usecase";
import { ICustomerEntity } from "../../../Services/api/customers/customers.interface";
import { useNavigate } from "react-router-dom";

interface IUseListArtsProps {
  listArtsUseCase: ListArtsUseCase
  destroyArtsUseCase: DestroyArtsUseCase
  listCustomersUseCase: ListCustomersUseCase
}
export function useListArts({ listArtsUseCase, destroyArtsUseCase, listCustomersUseCase }: IUseListArtsProps){
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<IArtEntity[]>([])
    const [artToDestroy, setArtToDestroy] = useState('')
    const [totalRegisters, setTotalRegisters] = useState(1)

    const [pageCustomer, setPageCustomer] = useState(1)
    const [dataCustomer, setDataCustomer] = useState<ICustomerEntity[]>([])
    const [totalRegistersCustomer, setTotalRegistersCustomer] = useState(1)
   
    const { showToast } =  useToast()
    const navigate = useNavigate()

    // const listArts = async ({ page: currentPage }: any) => {
        
    //     try {
    //       setLoading(true)
          
    //       const listResult = await listArtsUseCase.handle(currentPage);

    //       if (listResult.isFailure) {
       
    //         showToast(String(listResult?.error?.error), 'error');
    //         return;
    //       }

    //      const list = listResult.getValue()

       
    //         setData(list?.data || [])
    //         setTotalRegisters(list?.data?.length || 0)
         

    
    //      setPage(currentPage)
    //     } catch (error) {
    //       console.log("error listArts function: ", error)
    //     } finally {
    //       setLoading(false);
    //     }
    // };

    const loadCustomers = async ({ page: currentPage, search }: any) => {
        
      try {
        setLoading(true)
        
        const listResult = await listCustomersUseCase.handle({ page: currentPage, searchBy: search, personType: 'PJ'});

        if (listResult.isFailure) {
     
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

       const list = listResult.getValue()

     
        setDataCustomer(list?.data || [])
        setTotalRegistersCustomer(list?.data?.length || 0)
       

  
       setPage(currentPage)
      } catch (error) {
        console.log("error listCustomers function: ", error)
      } finally {
        setLoading(false);
      }
  };

    const list = useMemo(() => {
        const rows = data?.map(product => {

            return {
                id: product.id,
                code: product.id,
                size: product.customerId
            }
        })

        return rows
    }, [data])

    const handleDestroyArt = async () => {
        
      try {
        setLoading(true)
        
        const destroyResult = await destroyArtsUseCase.handle(artToDestroy);

        if (destroyResult.isFailure) {
     
          showToast(String(destroyResult?.error?.error), 'error');
          return;
        }

        setArtToDestroy('')
        showToast('Removido com sucesso.', 'success');

      //  await listArts({ page: 1 });
      } catch (error) {
        console.log("error destroyArts function: ", error)
      } finally {
        setLoading(false);
      }
    };

    const listCustomers = useMemo(() => {
      const rows = dataCustomer?.map(customer => {

          return {
              id: customer.id,
              name: customer.name,
              document: customer.document,
          }
      })

      return rows
  }, [dataCustomer])

      

    return {
        loading,
        // listArts,
        list,
        data,
        setArtToDestroy,
        artToDestroy,
        handleDestroyArt,
        totalRegisters,
        listCustomers,
        loadCustomers,
        totalRegistersCustomer,
        navigate
        
    }
}